import React from "react";
import { Helmet } from "react-helmet-async";
import AboutTrainingKedinasan from "../Components/AboutTraining/AboutTrainingKedinasan";
import Benefit from "../Components/Benefit/Benefit";
import Fasilitas from "../Components/Fasilitas/Fasilitas";
import FloatCta from "../Components/FloatCta/FloatCta";
import Footer from "../Components/Footer/Footer";
import Gallery from "../Components/Gallery/Gallery";
import HalDitanyakanKedinasan from "../Components/HalDitanyakan/HalDitanyakanKedinasan";
import Liputan from "../Components/Liputan/Liputan";
import MasterTeacher from "../Components/MasterTeacher/MasterTeacher";
import MateriKedinasan from "../Components/Materi/MateriKedinasan";
import Navbar from "../Components/Navbar/Navbar";
import PaketBelajar from "../Components/PaketBelajar/PaketBelajar";
import SectionDaftar from "../Components/SectionDaftar/SectionDaftar";
import Testimoni from "../Components/Testimoni/Testimoni";
import CtaBottomKedinasan from "../ComponentsKedinasan/CtaBottomKedinasan/CtaBottomKedinasan";
import JumbotronKedinasan from "../ComponentsKedinasan/JumbotronKedinasan/JumbotronKedinasan";
import LogoKedinasan from "../ComponentsKedinasan/LogoKedinasan/LogoKedinasan";
import TargetBelajarKedinasan from "../ComponentsKedinasan/TargetBelajarKedinasan/TargetBelajarKedinasan";

const HalamanKedinasan = () => {
  return (
    <React.Fragment>
      <Helmet>
        <meta
          charSet="utf-8"
          name="description"
          content="Bimbek SKD Kedinasan Materi terupdate, fasilitas terlengkap, pengajar profesional & jaminan lulus kedinasan. Bimbel kedinasan terlengkap, STAN, IPDN, STIS, STMKG, STTD, STIN, POLTEKIM & POLTEKIP."
        />
        <title>
          Bimbel Masuk Sekolah Kedinasan - IPDN STAN STIS STIN STPN STMKG STPI
          POLTEKIM POLTEKIP POLTEK SSN STTD STPN PPI - Taruna Persada
        </title>
        <link
          rel="canonical"
          href="https://camp.tarunapersada.com/bimbel-sekolah-kedinasan/"
        />
      </Helmet>
      <Navbar />
      <JumbotronKedinasan />
      <LogoKedinasan />
      <AboutTrainingKedinasan />
      <Benefit />
      <TargetBelajarKedinasan />
      <PaketBelajar />
      <SectionDaftar />
      <Gallery />
      <Fasilitas />
      {/* <Cta /> */}
      <MateriKedinasan />
      <Testimoni />
      <HalDitanyakanKedinasan />
      <MasterTeacher />
      <Liputan />
      <CtaBottomKedinasan />
      <Footer />
      <FloatCta />
    </React.Fragment>
  );
};

export default HalamanKedinasan;
